module.exports = __webpack_public_path__ + "static/media/cambara-do-sul-rs.065738cd.jpg";